// @core/api/endpoints/booking/complete_booking.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BookingLifecycleResponse,
  CompleteBookingRequest,
} from '../../../types/booking';

const BASE_PATH = '/booking';

/**
 * Complete booking
 * Marks a booking as COMPLETED. Triggers final payment (if balance remaining), sends review request notification to customer. Domain services consume booking.completed to trigger their post-completion logic.
 */
export async function CompleteBooking(
  target_type: string,
  target_id: string,
  data: CompleteBookingRequest,
  options?: RequestOptions
): Promise<BookingLifecycleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/booking/:target_type/:target_id/complete`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  const requestOptions = options;
  return client.post<BookingLifecycleResponse>(requestPath, data, requestOptions);
}
